<template>
  <div class="container">
    <div class="regard-home">
      <div class="regard-home-content regard-home-content-1">
        <div class="l-regard-view l-regard-view-1">
          <span class="l-rv-title">关于播聘</span>
          <div class="l-rv-content">用播聘好玩又赚钱</div>
        </div>
      </div>
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyHome",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped="scoped">
@import url("./company-home.css");
</style>



// WEBPACK FOOTER //
// src/pages/company-home/company-home.vue